module.exports = __webpack_public_path__ + "img/CellHost-500x500.df11fe5a.png";